import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Col, Typography, Button, Divider, Space } from 'antd';
import { UserAddOutlined } from '@ant-design/icons';
import { ReactComponent as MedicineSvg } from '../../../../assets/icons/sign-up/medicine.svg';

const { Title, Paragraph } = Typography;

function MobileFinishScreen() {
  const { t } = useTranslation(['sign-up', 'common']);
  const history = useHistory();

  const onConfirm = () => {
    history.push('/sign-up/guest/add-family-member')
  }

  const onCancel = () => {
    history.push('/sign-up/guest/thank-you')
  }

  return (
    <>
      <Row justify="center" style={{ padding: 0, marginBottom: 23 }}>
        <Title level={4} style={styles.text1}>
          {t('sign-up:guest.signUpComplete')}
        </Title>
      </Row>
      <Box display="flex" justifyContent="center">
        <MedicineSvg style={{ margin: '20', maxWidth: '80%' }} />
      </Box>
      <Box marginTop={30}>
        <Box marginBottom={30}>
          <Paragraph style={styles.text2}>
            {t('sign-up:guest.yourAllSet')}
          </Paragraph>
        </Box>
        <Box marginBottom={20}>
          <Paragraph style={styles.text3}>
            {t('sign-up:guest.thankYouForSignupAlemhealth')}
          </Paragraph>
        </Box>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Button
            htmlType="button"
            type="primary"
            size="large"
            onClick={onConfirm}
            block
            ghost
            icon={<UserAddOutlined />}
          >
            {t('sign-up:guest.addFamilyMember')}
          </Button>
          <Button
            htmlType="button"
            type="primary"
            size="large"
            onClick={onCancel}
            block
          >
            {t('sign-up:guest.skipAndFinishSignup')}
          </Button>
        </Space>
      </Box>
    </>
  );
}

const styles = {
  text1: {
    fontWeight: "500", 
    fontSize: "14px", 
    lineHeight: "17px", 
    textAlign: "center", 
    color: "#15A9E1"
  },
  text2: {
    fontWeight: "400", 
    fontSize: "24px", 
    lineHeight: "29px", 
    textAlign: "center", 
    color: "#15A9E1"
  },
  text3: {
    fontWeight: "300", 
    fontSize: "18px", 
    lineHeight: "28px", 
    textAlign: "center", 
    color: "#404047"
  }
}

export default MobileFinishScreen;
